export default __webpack_public_path__ + "static/media/brago-screenshot-01.8b3ccece.png";